import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable()
export class BusinessLogService {
  constructor(private http: HttpClient) {}

  getAllLogs(businessId: number) {
    return this.http.get<any[]>(
      `${environment.BASE_URL_V2}/accesslogs/${businessId}/history`
    );
  }

  getAllLogsUserName(businessId: number, loginDate: string) {
    // LogOn identifies a calendar day; do not shift it through the browser timezone.
    const day = loginDate.slice(0, 10);
    return this.http.get<any[]>(
      `${environment.BASE_URL_V2}/accesslogs/${businessId}/users/${encodeURIComponent(day)}`
    );
  }
}
